import { useResponsive } from '../../hooks';
import { ThemeSpacing } from '../../theme/shared';

export const useGetThemeSize = (sizeProp?: ThemeSpacing): ThemeSpacing => {
  const { isMobile } = useResponsive();
  const responsiveSize: ThemeSpacing = isMobile ? 'sm' : 'md';

  return sizeProp ? sizeProp : responsiveSize;
};
